import { render, staticRenderFns } from "./projectZjIndex.vue?vue&type=template&id=66153b82"
import script from "./projectZjIndex.vue?vue&type=script&lang=js"
export * from "./projectZjIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports